import { ReactElement } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import styles from './Header.module.scss';
import A from '../A';
import { GO_TO_EXISTING_USER_LOGIN } from '../../services/analytics-client';
import { BASE_PATH } from '../../services/public-config';
import { getNextPageUrl } from '../../utils/helper';

export default function Header(): ReactElement {
  const router = useRouter();
  const nextPageUrl = getNextPageUrl(router);
  const next = nextPageUrl ? `?next=${nextPageUrl}` : '';

  return (
    <header className={styles.header}>
      <a href="https://saucelabs.com/" title="Sauce Labs" className={styles.logo}>
        <Image src={`${BASE_PATH}/sauce-logo.svg`} alt="Sauce Labs logo" width={205} height={40} />
      </a>
      <div className={styles['sign-in-container']}>
        <span>Already have an account?</span>
        <A variant="button" href={`https://accounts.saucelabs.com/am/XUI/${next}`} trackingEventName={GO_TO_EXISTING_USER_LOGIN}>
          Sign in
        </A>
      </div>
    </header>
  );
}
